"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Monitoring_1 = require("../monitoring/Monitoring");
var NullInteractionMonitor = /** @class */ (function () {
    function NullInteractionMonitor() {
    }
    NullInteractionMonitor.prototype.createTracer = function (name) {
        return function () {
            /*no-op*/
        };
    };
    return NullInteractionMonitor;
}());
var InteractionMonitor = /** @class */ (function () {
    function InteractionMonitor(interaction) {
        this.interaction = interaction;
    }
    InteractionMonitor.createInstance = function (interaction) {
        if (Monitoring_1.isMonitoringActivated() && interaction) {
            this.instance = new InteractionMonitor(interaction);
        }
        else {
            this.instance = new NullInteractionMonitor();
        }
    };
    InteractionMonitor.getInstance = function () {
        return this.instance;
    };
    InteractionMonitor.prototype.createTracer = function (name) {
        if (this.interaction !== null) {
            try {
                return this.interaction.createTracer(name);
            }
            catch (e) {
                console.error(e);
            }
        }
        return function () {
            /*no-op*/
        };
    };
    InteractionMonitor.instance = new NullInteractionMonitor();
    return InteractionMonitor;
}());
exports.InteractionMonitor = InteractionMonitor;
//# sourceMappingURL=InteractionMonitoring.js.map